import { POST_USER_SUCCESS } from 'stash/actions/api/user';
import {
	GET_ACCOUNTS_SUCCESS,
	POST_ACCOUNT_SUBMIT_SUCCESS,
	POST_ACCOUNT_SUCCESS,
} from 'stash/actions/api/account';

import { BOOTSTRAP_GET_ACCOUNTS_SUCCESS } from 'stash/store/bootstrapActions';

const account = (state = {}, action) => {
	switch (action.type) {
		case POST_USER_SUCCESS:
		case BOOTSTRAP_GET_ACCOUNTS_SUCCESS:
			return action.response.accounts.reduce(
				(accumulator, account) => ({
					...accumulator,
					[account.id]: {
						...state[account.id],
						...account,
					},
				}),
				{}
			);

		case POST_ACCOUNT_SUCCESS:
		case POST_ACCOUNT_SUBMIT_SUCCESS: {
			const account = action.response.account;

			return {
				...state,
				[account.id]: account,
			};
		}

		case GET_ACCOUNTS_SUCCESS: {
			const accountsArr = action?.response?.accounts;
			return accountsArr.reduce((acc, curr) => {
				acc[curr.id] = curr;
				return acc;
			}, {});
		}

		default:
			return state;
	}
};

export default account;
